import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ScriptEditor from "./scriptEditor";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<ScriptEditor />);
